module.exports = __webpack_public_path__ + "static/media/day-25-measurements.ec83fb84.svg";